import { useState } from "react";
import { useLanguage } from "../../../contexts/LanguageContext";

/**
 * Modal (Create/Update) form state & işlemleri
 */
const useExternalVehicleForm = (saveVehicle) => {
  const { th } = useLanguage();

  // dialog & mode
  const [dialogVisible, setDialogVisible] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [currentVehicle, setCurrentVehicle] = useState(null);
  const [submitted, setSubmitted] = useState(false);

  // form alanları
  const [brand, setBrand] = useState("");
  const [model, setModel] = useState("");
  const [chassisNo, setChassisNo] = useState("");
  const [licensePlate, setLicensePlate] = useState("");

  const resetForm = () => {
    setBrand("");
    setModel("");
    setChassisNo("");
    setLicensePlate("");
  };

  const setFormData = (vehicle) => {
    setBrand(vehicle.brand || "");
    setModel(vehicle.model || "");
    setChassisNo(vehicle.chassisNo || "");
    setLicensePlate(vehicle.licensePlate || "");
  };

  const handleAddNew = () => {
    setEditMode(false);
    setCurrentVehicle(null);
    resetForm();
    setSubmitted(false);
    setDialogVisible(true);
  };

  const handleEdit = (vehicle) => {
    setEditMode(true);
    setCurrentVehicle(vehicle);
    setFormData(vehicle);
    setSubmitted(false);
    setDialogVisible(true);
  };

  const hideDialog = () => setDialogVisible(false);

  const handleSubmit = async () => {
    setSubmitted(true);

    // Brand, Model ve ChassisNo zorunlu
    if (brand.trim() && model.trim() && chassisNo.trim()) {
      const payload = {
        id: editMode ? currentVehicle?.id : undefined,
        brand: brand.trim(),
        model: model.trim(),
        chassisNo: chassisNo.trim(),
        licensePlate: licensePlate.trim() || null
      };

      // Edit modunda id ekle
      if (editMode && currentVehicle) {
        payload.id = currentVehicle.id;
      }

      const ok = await saveVehicle(payload, editMode, currentVehicle);
      if (ok) hideDialog();
      return ok;
    }
    return false;
  };

  const renderDialogFooter = () => (
    <div className="flex justify-content-end gap-2">
      <button
        className="p-button p-component p-button-outlined"
        type="button"
        onClick={hideDialog}
      >
        <span className="p-button-icon p-button-icon-left pi pi-times"></span>
        <span className="p-button-label">{th("common.cancel")}</span>
      </button>
      <button className="p-button p-component" onClick={handleSubmit}>
        <span className="p-button-icon p-button-icon-left pi pi-check"></span>
        <span className="p-button-label">{th("common.save")}</span>
      </button>
    </div>
  );

  return {
    // dialog
    dialogVisible,
    editMode,
    submitted,
    hideDialog,
    handleAddNew,
    handleEdit,
    handleSubmit,
    renderDialogFooter,

    // fields
    brand,
    model,
    chassisNo,
    licensePlate,
    setBrand,
    setModel,
    setChassisNo,
    setLicensePlate
  };
};

export default useExternalVehicleForm;
